import { Layout } from "@/components/Layout";
import { Leaf, ExternalLink, Mountain, Bird, Sprout } from "lucide-react";

export default function MontePisanoPage() {
  return (
    <Layout>
      <section className="bg-[#1f2d22] text-white py-16 sm:py-20" data-testid="monte-pisano-header">
        <div className="max-w-4xl mx-auto px-6 sm:px-8 lg:px-12">
          <div className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 mb-5">
            <Leaf className="w-3.5 h-3.5 text-[#E8C9A0]" />
            <span className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.22em] text-[#E8C9A0]">
              Rete Natura 2000
            </span>
          </div>
          <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black leading-[1.05] tracking-tight">
            Monte Pisano <span className="italic font-light text-[#E8C9A0]">Natura 2000.</span>
          </h1>
          <p className="mt-5 text-base sm:text-lg text-white/75 max-w-2xl leading-relaxed">
            Habitat, biodiversità, flora e fauna del nostro territorio. Un patrimonio
            naturale protetto e da tutelare.
          </p>
        </div>
      </section>

      <section className="py-14 sm:py-20 bg-[#FBF9F6]">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 lg:px-12 space-y-10">
          <p className="text-lg sm:text-xl text-[#1A1A1A] font-semibold leading-relaxed italic">
            Il Monte Pisano è parte della Rete Natura 2000, il principale strumento
            europeo per la conservazione della biodiversità.
          </p>

          <div className="grid sm:grid-cols-3 gap-4">
            {[
              { icon: Mountain, title: "Habitat protetti", desc: "Boschi, macchia mediterranea e zone umide tutelati a livello europeo." },
              { icon: Sprout, title: "Flora caratteristica", desc: "Lecci, querce, castagni e specie endemiche del Monte Pisano." },
              { icon: Bird, title: "Fauna locale", desc: "Cinghiali, daini, rapaci diurni e numerose specie protette." },
            ].map((c) => {
              const Icon = c.icon;
              return (
                <div key={c.title} className="rounded-2xl bg-white border-2 border-[#E5E1D8] p-6">
                  <div className="w-12 h-12 rounded-xl bg-[#2E4F3B] text-white flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6" />
                  </div>
                  <h3 className="font-display text-lg font-black text-[#1A1A1A] mb-2">{c.title}</h3>
                  <p className="text-sm text-[#5C5C5C] leading-relaxed">{c.desc}</p>
                </div>
              );
            })}
          </div>

          <div className="text-base sm:text-lg text-[#3F3F3F] leading-relaxed space-y-4">
            <p>
              Stiamo lavorando a una pagina di approfondimento dedicata all'ecosistema del
              Monte Pisano, con schede su habitat, specie tutelate e indicazioni di
              comportamento per chi frequenta il territorio.
            </p>
            <p className="italic text-[#5C5C5C]">
              Nel frattempo, per informazioni ufficiali puoi consultare il sito della
              Regione Toscana e il geoportale.
            </p>
          </div>

          <div className="flex flex-wrap gap-3">
            <a
              href="https://www.regione.toscana.it/-/rete-natura-2000-in-toscana"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="monte-pisano-natura2000-link"
              className="inline-flex items-center gap-2 rounded-full bg-[#2E4F3B] hover:bg-[#1f3828] text-white font-bold px-6 py-3 transition-colors"
            >
              Rete Natura 2000 in Toscana
              <ExternalLink className="w-4 h-4" />
            </a>
            <a
              href="https://geoportale.lamma.rete.toscana.it/difesa_suolo/#/viewer/265"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="monte-pisano-geoportale-link"
              className="inline-flex items-center gap-2 rounded-full bg-white border-2 border-[#1A1A1A] hover:bg-[#1A1A1A] hover:text-white text-[#1A1A1A] font-bold px-6 py-3 transition-colors"
            >
              Geoportale
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        </div>
      </section>
    </Layout>
  );
}
